import type { PlaceResult } from "@/lib/api/misc";

export function normalizePlaceDisplay(value: string) {
  return value
    .toLowerCase()
    .replace(/,\s*india$/, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function resolveExactPlaceInput(query: string, results: PlaceResult[]): PlaceResult | null {
  const normalizedQuery = normalizePlaceDisplay(query);
  if (!normalizedQuery) return null;
  return (
    results.find((place) => {
      const display = normalizePlaceDisplay(place.display);
      const name = normalizePlaceDisplay(place.name);
      return display === normalizedQuery || name === normalizedQuery;
    }) ?? null
  );
}
